import React, { useState, useEffect, useCallback, useMemo } from 'react';
import FeedbackListItem from './FeedbackListItem';
import { getAll } from '../../services/FeedbackService';
import { useAuth } from '../../contexts/AuthProvider';
import Pagination from '../utils/Paginations';
import UserDropdown from '../users/UserDropdown';
import './FeedbackList.css';

function FeedbackList() {
  const { userToken } = useAuth();

  const [allFeedbacks, setAllFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 8;
  const [totalFeedbacks, setTotalFeedbacks] = useState(0);

  const loadAllFeedbacks = useCallback(async () => {
    setLoading(true);
    try {
      const { feedbacks, count } = await getAll(userToken);
      setAllFeedbacks(feedbacks);
      setTotalFeedbacks(count);
    } catch (err) {
      console.error('Erro ao buscar feedbacks:', err);
    } finally {
      setLoading(false);
    }
  }, [userToken]);

  const pagedFeedbacks = useMemo(() => {
    const start = currentPage * pageSize;
    return allFeedbacks.slice(start, start + pageSize);
  }, [allFeedbacks, currentPage, pageSize]);

  useEffect(() => {
    loadAllFeedbacks();
  }, [loadAllFeedbacks]);

  if (loading) return null;

  return (
    <div className="feedback-table-content">
      <div className='user-list-content'>
        <p className='user-table-title'>Feedbacks</p>
        <UserDropdown></UserDropdown>
      </div>

      <table className="table-feedback">
        <thead className="feedback-table-head table-header">
          <tr>
            <th className="col-3">Feedback</th>
            <th className="col-3">Chat relacionado</th>
            <th className="col-3">Texto</th>
            <th className="col-2">Data e hora</th>
          </tr>
        </thead>
        <tbody className="feedback-table-body">
          {pagedFeedbacks.map((fb, idx) => (
            <FeedbackListItem key={idx} feedback={fb} />
          ))}
        </tbody>
      </table>

      <Pagination
        cPage={currentPage}
        pageSize={pageSize}
        countOrders={totalFeedbacks}
        updateTablePage={setCurrentPage}
      />
    </div>
  );
}

export default FeedbackList;
